import { Component, OnInit, ViewContainerRef, Input, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';
import { ToastsManager } from 'ng2-toastr';
import { Router } from '@angular/router';
import { Globals } from '../../../globals';
@Component({
    selector: 'app-fmsingup',
    templateUrl: './fmsingup.component.html',
    styleUrls: ['./fmsingup.component.css']
})
export class FmsingupComponent implements OnInit, OnDestroy {


    public type = "password";
    public type1 = "password";
    fm: FormGroup;
    public token: any = {
        singup: "api/signup",
    }
    public connect;
    constructor(public fb: FormBuilder, public toastr: ToastsManager,
        vcr: ViewContainerRef, public router: Router, public globals: Globals) {
        this.toastr.setRootViewContainerRef(vcr);
        this.fm = this.fb.group({
            name: ['', [Validators.required, Validators.minLength(5)]],
            email: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)]],
            password: ['', [Validators.required]],
            sex: 1
        });
        this.connect = this.globals.result.subscribe((res: any) => {
            switch (res.token) {
                case 'singup':
                    let type = (res['status'] == 1) ? "success" : (res['status'] == 0 ? "warning" : "danger");
                    this.toastr[type](res['message'], type);
                    if (res['status'] == 1) {
                        setTimeout(() => {
                            //this.globals.CUSTOMER.set(res['data'], true);
                            this.router.navigate(['/dang-nhap']);
                        }, 500);
                    }
                    break;
                default:
                    break;
            }
        });
    }
    ngOnInit() {

    }
    ngOnDestroy() {
        if (this.connect) {
            this.connect.unsubscribe();
        }
    }
    onSubmit() {
        let data: any = this.fm.value;
        this.globals.send({ path: this.token.singup, token: "singup", data: data });
    }

}



// WEBPACK FOOTER //
// ./src/app/frontend/modules/fmsingup/fmsingup.component.ts